import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { duplicateQuote } from '../api/quotesApi';

// Wraps POST /DuplicateQuote/{id} → { quoteId }. Server broadcasts
// UpdateQuoteTable; useQuotes owns the invalidation via its SignalR listener.
// Caller navigates to /quotes/{quoteId}.
export default function useDuplicateQuote() {
    return useMutation({
        mutationFn: ({ id, customerId }) => duplicateQuote(id, customerId),
        onSuccess: () => toast.success('Quote duplicated'),
        onError: (err) => toast.error(err?.message ?? 'Failed to duplicate quote'),
    });
}
